var exports = {
  "iE": "xaee3c4fa--5b38ff--wrapper",
  "DD": "xaee3c4fa--5b38ff--title",
  "h_": "xaee3c4fa--5b38ff--description",
  "NL": "xaee3c4fa--5b38ff--switch-wrapper",
};

module.exports = exports;
